module["exports"] = [
  "AG",
  "GmbH",
  "und Söhne",
  "und Partner",
  "& Co.",
  "Gruppe",
  "LLC",
  "Inc."
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/de_CH/company/suffix.js
// module id = 2531
// module chunks = 1610